import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Resolver для корня `/profile`: admin-пользователи попадают на вкладку
 * «Администрирование» (как в оригинальной реализации, пока вкладки были на
 * signal'ах), остальные — на «Настройки». Применяется вместо статического
 * `redirectTo: 'settings'` в child-route с `path: ''`.
 */
export const defaultProfileTabGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const tab = auth.currentUser()?.role === 'admin' ? 'admin' : 'settings';
  return router.createUrlTree(['/profile', tab]);
};
